/**
 * TrainerEvaluations — full list of evaluations on MY sessions, paginated by
 * the backend. Mobile card layout with star rating + optional comment.
 */
import React, { useEffect, useState } from 'react';
import api from '../../api/client';
import { Loader2, Star } from 'lucide-react';

export default function TrainerEvaluations() {
  const [items, setItems] = useState(null);
  useEffect(() => {
    api.get('/me/trainer/recent-evaluations?limit=20').then((r) => setItems(r.data)).catch(() => setItems([]));
  }, []);

  return (
    <div className="space-y-4" data-testid="trainer-evaluations-page">
      <h1 className="text-[22px] font-bold text-[#1A1B2E]" style={{ fontFamily: "'Plus Jakarta Sans', sans-serif" }}>Mes évaluations</h1>
      <p className="text-[12.5px] text-[#6B6C85]">Avis laissés par les stagiaires sur vos sessions.</p>

      {items === null && <div className="flex items-center justify-center py-12"><Loader2 className="w-5 h-5 animate-spin text-[#4F46E5]" /></div>}
      {items && items.length === 0 && (
        <div className="soft-card p-6 text-center text-[12.5px] italic text-[#8E8FA5]">
          Aucune évaluation reçue pour le moment.
        </div>
      )}
      {items && items.map((ev, i) => (
        <div key={ev.id || i} className="soft-card p-4" data-testid={`trainer-evaluation-${i}`}>
          <div className="flex items-center justify-between mb-1">
            <div className="text-[13px] font-semibold text-[#1A1B2E]">{ev.learner_name || ev.author || 'Stagiaire'}</div>
            <Stars value={ev.rating ?? ev.score ?? ev.average} />
          </div>
          {ev.comment && <p className="text-[12px] text-[#4A4B63] mt-1">{ev.comment}</p>}
          <div className="text-[10.5px] text-[#8E8FA5] mt-1.5">
            {ev.session_id && <>Session {ev.session_id}</>}
            {ev.created_at && <> · {new Date(ev.created_at).toLocaleDateString('fr-FR')}</>}
          </div>
        </div>
      ))}
    </div>
  );
}

function Stars({ value }) {
  const v = Number(value || 0);
  if (!v) return <span className="text-[10.5px] text-[#8E8FA5]">—</span>;
  return (
    <div className="flex items-center gap-0.5">
      {[1, 2, 3, 4, 5].map((i) => (
        <Star key={i} className={`w-3.5 h-3.5 ${i <= Math.round(v) ? 'fill-[#F59E0B] text-[#F59E0B]' : 'text-[#E5E7EB]'}`} />
      ))}
    </div>
  );
}
